import type { PricingStrategyProfileResponse } from '@/shared/api';
import { ConfigurationDetails } from './ConfigurationDetails';
import { ProfileComparisonCards } from './ProfileComparisonCards';
import { ProfileComparisonTable } from './ProfileComparisonTable';
import type { ProfileComparisonSection } from './profileComparisonRows';

/** „Regelwerk vergleichen“: alle Profilwerte nebeneinander, am schmalen Container als Karten. */
export function StrategyProfileRuleDetails({
  profiles,
  sections,
  selectedProfileVersionId,
}: {
  profiles: PricingStrategyProfileResponse[];
  sections: ProfileComparisonSection[];
  selectedProfileVersionId: string | null;
}) {
  return (
    <ConfigurationDetails title="Regelwerk vergleichen">
      <ProfileComparisonTable {...{ profiles, sections, selectedProfileVersionId }} />
      <ProfileComparisonCards profiles={profiles} sections={sections} />
    </ConfigurationDetails>
  );
}
